<template lang="pug">
.upcoming-card(:class="{ 'active' : selectedMatch == source.matchId}" @click="setMenu(source.matchId)")
  //- small {{ source }}
  .info
    span.league {{ source.leagueName }}
    span(v-if="source.marketId != 3") {{ source.runningTime }}
    //- span(v-else) {{ source.matchTime }}
    TimePanel(v-else :source="source" isMore=true)
  .team
    span.name {{ source.homeTeam }}
    .red-card(v-if="source.matchBody && source.matchBody[24] > 0 && source.matchBody[4] == 3")
      img.img-fluid(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'" alt='')
    span.score(v-if="source.marketId == 3") {{ source.runningScore ? source.runningScore.split('-')[0] : '0' }}
  .team
    span.name {{ source.awayTeam }}
    .red-card(v-if="source.matchBody && source.matchBody[25] > 0 && source.matchBody[4] == 3")
      img.img-fluid(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'" alt='')
    span.score(v-if="source.marketId == 3") {{ source.runningScore ? source.runningScore.split('-')[1] : '0' }}

//- li.league-card
//-   a(data-toggle='tab' :href="'#' + source.id" :class="{ 'active' : selectedMatch == source.matchId}" @click="setMenu(source.matchId)")
//-     .match-info(:class="{ 'live' : source.marketId == 3 || [41, 42, 43, 44, 47].includes(source.sportsId) }")
//-       .d-flex.match-info-team
//-         .match-info-home-name.pl-1(:class="source.details['team'] == 1 ? 'team-red' : 'team-black'")
//-           .foul-card(v-if="source.matchBody[24] > 0 && source.matchBody[4] == 3")
//-             img(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'")
//-           .name.more-match-name {{ source.homeTeam }}
//-         TimePanel(:source="source")
//-         .match-info-away-name.pr-1(:class="source.details['team'] == 0 ? 'team-red' : 'team-black'")
//-           .name.more-match-name {{ source.awayTeam }}
//-           .foul-card(v-if="source.matchBody[25] > 0 && source.matchBody[4] == 3")
//-             img(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'")
</template>


<script>
import TimePanel from "@/components/mobile/main/timePanel";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    TimePanel
  },
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object
    }
  },
  computed: {
    selectedMatch() {
      return this.$store.getters.selectedMatch;
    }
  },
  mounted() {
    var scroll = document.querySelector(".upcoming-card.active");
    scroll.scrollIntoView({
      inline: "center"
    });
  },
  methods: {
    setMenu(matchId) {
      this.$store.dispatch("layout/setSelectedMatch", matchId);
      EventBus.$emit("INVALIDATE");
    }
  }
}
</script>